<template>
  <div class="main-page second">
    <div class="container">
      <div class="py-4 return"><a href="#">back 👈</a></div>
      <div class="row">
        <!-- profile card -->
        <div class="col-lg-4 left">
          <div class="profile_info">
            <div class="seller-card">
              <!-- <div>
                <div
                  class="user-online-indicator is-online"
                  data-user-id="1152855"
                >
                  <i class="fa fa-circle"></i>online
                </div>
              </div> -->
              <div class="user-profile-header">
                <div class="user-profile-image">
                  <label class="user-pict">
                    <img
                      src="@/assets/images/profile.png"
                      class="img-fluid user-pict-img"
                      alt="Askbootstrap" />
                    <a
                      href="#"
                      class="user-badge-round user-badge-round-med locale-en-us top-rated-seller"
                    ></a
                  ></label>
                </div>
                <div>
                  <a href="#" class="btn-lrg-standard">Update Profile</a>
                </div>
              </div>

              <div class="user-profile-info">
                <div class="user-profile-label">
                  <div class="username-line">
                    <a href="#" class="seller-link">Gloria Amaka</a>
                  </div>
                  <div class="oneliner-wrapper">
                    <small class="oneliner"
                      >Artificial Intelligence Trainee</small
                    >
                  </div>
                </div>
              </div>
              <!-- <div class="buttons-wrapper">
                <a
                  href="#"
                  class="btn-lrg-standard btn-contact-me js-contact-me js-open-popup-join"
                  >Update Profile</a
                >
              </div> -->
            </div>

            <div class="seller-profile">
              <div class="description">
                <h3>Description</h3>
                <p>
                  I am a Artificial Intelligence Trainee from Nigeria. I like
                  everything from video games to phone systems to explainer
                  videos to children's books. I am originally from the South
                  East of Nigeria.
                </p>
              </div>
              <div class="country">
                <h3>Country</h3>
                <p>🇳🇬 Nigeria</p>
              </div>
              <div class="languages">
                <h3>Languages</h3>
                <ul>
                  <li>English</li>
                  <li>French</li>
                </ul>
              </div>

              <div class="skills">
                <h3>Skills</h3>
                <ul>
                  <li class=""><a href="#">Machine Learning</a></li>
                  <li class=""><a href="#">Artificial Intelligence</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- end profile card -->

        <div class="col-lg-8 right">
          <h2>My Courses 👩‍💻</h2>
          <div class="recommended">
            <div class="row">
              <div class="col-md-5">
                <div class="recommended-body">
                  <a href="#">
                    <img class="img-fluid" src="@/assets/images/ai-guide.png" />
                  </a>
                  <div class="inner-slider">
                    <div class="inner-wrapper">
                      <div class="d-flex align-items-center">
                        <span class="seller-image">
                          <img
                            class="img-fluid"
                            src="@/assets/images/trainer.png"
                            alt=""
                          />
                        </span>
                        <span class="seller-name">
                          <a href="training_area">Ultimate AI Guide</a>
                          <span class="level hint--top level-one-seller">
                            20 Mins Ago
                          </span>
                        </span>
                      </div>
                      <p>Start building Machine Learning Models that scale</p>

                      <div class="footer">
                        <div class="progressbar">
                          <div
                            class="progressbar_value"
                            :style="progressBarStyles"
                          ></div>
                        </div>

                        <div class="continue-learning">
                          <a href="training_area"
                            ><span>Continue Learning</span
                            ><span><i class="fas fa-chevron-right"></i></span
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-5">
                <div class="recommended-body">
                  <a href="#">
                    <img class="img-fluid" src="@/assets/images/bc.png" />
                  </a>
                  <div class="inner-slider">
                    <div class="inner-wrapper">
                      <div class="d-flex align-items-center">
                        <span class="seller-image">
                          <img
                            class="img-fluid"
                            src="@/assets/images/trainer.png"
                            alt=""
                          />
                        </span>
                        <span class="seller-name">
                          <a href="training_area">Ultimate AI Guide</a>
                          <span class="level hint--top level-one-seller">
                            20 Mins Ago
                          </span>
                        </span>
                      </div>
                      <p>Start building Machine Learning Models that scale</p>

                      <div class="footer">
                        <div class="progressbar">
                          <div
                            class="progressbar_value"
                            :style="progressBarStyles"
                          ></div>
                        </div>

                        <div class="continue-learning">
                          <a href="training_area"
                            ><span>Continue Learning</span
                            ><span><i class="fas fa-chevron-right"></i></span
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "login",
  data() {
    return {
      error: false,
      success: false,
    };
  },
  computed: {},
  methods: {},
};
</script>
